import { stripLeadingSubprojectSegment } from "../utils/localePath"

export interface RedirectDefaultLocalePrefixOptions {
  /** 默认语言，英文站为 en */
  defaultLocale?: string
  /**
   * 子项目在 www 下的路径段（如 industry、price-center）。
   * 当请求来自 www 且路径含 /en 时，重定向目标会补上该前缀。
   */
  subprojectSegment?: string
  /** locale cookie 名称，与 next-intl 配置保持一致 */
  localeCookieName?: string
}

function buildTargetPathname(
  pathname: string,
  defaultLocale: string,
  options: Pick<RedirectDefaultLocalePrefixOptions, "subprojectSegment">,
  isWww: boolean
): string | null {
  const segments = pathname.split("/").filter(Boolean)
  if (segments[0] !== defaultLocale) {
    return null
  }

  const restSegments = segments.slice(1)
  const subprojectSegment = options.subprojectSegment?.replace(/^\/+|\/+$/g, "")

  if (isWww && subprojectSegment) {
    const pathSegments = stripLeadingSubprojectSegment(restSegments, subprojectSegment)
    return pathSegments.length > 0 ? `/${subprojectSegment}/${pathSegments.join("/")}` : `/${subprojectSegment}`
  }

  return restSegments.length > 0 ? `/${restSegments.join("/")}` : "/"
}

/**
 * 解析默认语言去前缀后的目标 pathname（纯函数，供单测与脚本验证使用）。
 */
export function resolveDefaultLocaleRedirectPathname(
  pathname: string,
  options: RedirectDefaultLocalePrefixOptions & { isWww?: boolean } = {}
): string | null {
  const defaultLocale = options.defaultLocale ?? "en"
  const isWww = options.isWww ?? true
  return buildTargetPathname(pathname, defaultLocale, options, isWww)
}
